import { SReducerState as SGrnEntryReducer } from './reducers/GrnEntry/types';
import { SBatchDetails, SGRNEntry, SClient } from './types';

export const ADD_BATCH = 'Add Batch';

export const INITIAL_STATE = {
  SBatchDetails: (): SBatchDetails => ({
    acceptedQty: 0,
    batchNo: '',
    expiry: null,
    mrp: 0,
    receivedQty: '',
    rejectedQty: 0,
    rejectedReason: '',
  }),
  SGRNEntry: (): SGRNEntry => ({
    openDetails: true,
    batchNo: '',
    name: '',
    id: '',
    expiry: null,
    gst: 0,
    mrp: 0,
    ptr: 0,
    poQty: 0,
    index: 0,
    rack: '',
    stockId: '',
    packaging: '',
    batchDetails: [INITIAL_STATE.SBatchDetails()],
  }),
  SClient: (): SClient => ({
    expandAll: false,
    totalGrn: 0,
    isValidBill: true,
    printState: {
      open: false,
      batchId: null,
    },
    addBatchState: {
      open: false,
      rowIndex: null,
      batchIndex: null,
      item: null,
    },
    focusedRowIndex: null,
    focusedBatchIndex: null,
    inventoryViewSku: '',
  }),
  SGrnEntry: (): SGrnEntryReducer => ({
    client: INITIAL_STATE.SClient(),
    rows: [INITIAL_STATE.SGRNEntry()],
  }),
};
